import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const GithubIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Github",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M15.99 2.34C8.25 2.34 2 8.6 2 16.33c0 6.15 3.96 11.37 9.47 13.25l.09.03c.7.13.96-.3.96-.67v-2.38c-3.9.87-4.71-1.87-4.71-1.87a3.7 3.7 0 0 0-1.55-2.05h-.01c-1.27-.88.09-.88.09-.88.92.13 1.69.67 2.13 1.43.51.94 1.49 1.56 2.61 1.56.54 0 1.04-.14 1.48-.39h-.01c.06-.72.39-1.38.87-1.87-3.11-.35-6.37-1.55-6.37-6.92v-.07c0-1.42.55-2.72 1.45-3.69-.18-.49-.28-1.07-.28-1.66 0-.73.16-1.44.44-2.07v.03s1.15-.35 3.83 1.46a13.34 13.34 0 0 1 7.09.02l-.09-.02c2.68-1.81 3.85-1.46 3.85-1.46.27.6.43 1.29.43 2.03 0 .6-.1 1.18-.29 1.71v-.03c.9.96 1.45 2.25 1.45 3.66v.09c0 5.38-3.28 6.55-6.38 6.9.6.6.97 1.43.97 2.35 0 .09 0 .19-.01.28v3.83c0 .46.25.81.97.67 5.6-1.92 9.54-7.13 9.54-13.27-.01-7.76-6.27-14.02-14.01-14.02Z"
      })
    }) : /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        d: "M16.01 0C7.16 0 0 7.21 0 16.13c0 7.13 4.59 13.17 10.95 15.3.8.16 1.09-.35 1.09-.77 0-.37-.03-1.66-.03-2.99-4.45.96-5.38-1.92-5.38-1.92-.72-1.87-1.78-2.35-1.78-2.35-1.46-.99.11-.99.11-.99 1.62.11 2.47 1.66 2.47 1.66 1.43 2.46 3.74 1.76 4.67 1.33.13-1.04.56-1.76 1.01-2.16-3.55-.37-7.29-1.76-7.29-7.96 0-1.76.64-3.2 1.64-4.33-.16-.4-.72-2.06.16-4.27 0 0 1.35-.43 4.4 1.66 1.31-.35 2.65-.53 4-.53s2.73.19 4 .53c3.05-2.08 4.4-1.66 4.4-1.66.88 2.22.32 3.87.16 4.27 1.03 1.12 1.64 2.56 1.64 4.33 0 6.2-3.74 7.56-7.32 7.96.58.51 1.09 1.47 1.09 2.99 0 2.16-.03 3.9-.03 4.43 0 .43.29.93 1.09.77A16.12 16.12 0 0 0 32 16.13C32.03 7.21 24.84 0 16.01 0"
      })
    })
  }));
};
GithubIcon.displayName = 'GithubIcon';